var React = require('react');

function SendWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3 20L21 12L3 4V10L15 12L3 14V20Z","fill":"white","transform":"rotate(-135 12 12)"}));
}

SendWhite.defaultProps = {"width":"20","height":"20","viewBox":"0 0 24 24","fill":"none"};

module.exports = SendWhite;

SendWhite.default = SendWhite;
